import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import Layout from '../components/core/live/layout'
import MetaData from '../components/core/metaData'
// import SlackImage from 'src/images/slack.svg'
import { startAndEndDate } from 'src/utils/date-helpers'
import ConferenceLiveSection from 'src/components/conferenceLiveSection'

const Live = ({ data, location }) => {
  const conference = data.conference
  conference.data.Sessions = data.sessions.nodes

  return (
    <Layout conference={conference} location={location}>
      <MetaData
        keywords={[
          'uxdx',
          'product',
          'ux',
          'design',
          'dev',
          'agile',
          'digital transformation',
          'conference',
          'success',
        ]}
        title={
          'Watch Live | ' +
          conference.data.Conference_Name +
          ' | ' +
          startAndEndDate(conference.data.Conference_Start_Date, conference.data.Conference_End_Date)
        }
        description="Check out the live stages, network with attendees, access extra on-demand content and develop your skills in our workshops!"
        image={conference.data.Meta_Home_Url}
      />

      <ConferenceLiveSection conference={conference} sessions={data.sessions.nodes} />
    </Layout>
  )
}

Live.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Live

export const postQuery = graphql`
  query ($id: String!) {
    conference: airtableConference(id: { eq: $id }) {
      data {
        Conference_Id
        Conference_Name
        Conference_Start_Date
        Conference_End_Date
        Conference_Venue_Type
        Live_Start_Time
        Location
        Region
        Type
        Year
        Days_Away
        Stats {
          id
          data {
            Stat
            Value
          }
        }
        Venue {
          data {
            Name
            Venue_City
            Venue_Address
            Venue_Type
            Country
            Post_Code
          }
        }
        Partners {
          data {
            Company_Name
            Company_Logo_Url
          }
        }
        Stage_Days {
          id
          data {
            Stage {
              data {
                Stage_Slug
                Stage_Priority
              }
            }
            UTC_Start_Time
            UTC_End_Time
            Conference {
              data {
                Conference_Id
              }
            }
            LiveStream
            Zoom
          }
        }
        Meta_Home_Url
      }
    }
    sessions: allAirtableSessions(
      filter: {
        data: {
          Conference: { elemMatch: { id: { eq: $id } } }
          Session_Status: { in: ["Published", "Confirmed"] }
        }
      }
      sort: { data: { UTC_Start_Time: ASC } }
    ) {
      nodes {
        id
        data {
          Talk_Title
          Talk_Description
          UTC_Start_Time
          UTC_End_Time
          Session_Slug
          Public_Release_Date
          Slideshare
          Calendar_Id
          Video
          Mux_Video
          Capacity
          Session_Status
          Speakers {
            id
            data {
              Person_Job_Title
              Person {
                id
                data {
                  Person_First
                  Person_Last
                  Person_Twitter
                  Person_Url_Slug
                  Person_Status
                  Person_Linkedin
                  Hide_Speaker
                  Person_Priority
                  Profile_Picture_Url_50
                  Profile_Picture_Url_250
                }
              }
              Company {
                data {
                  Company_Name
                  Company_Logo_Url
                }
              }
            }
          }
          Session_Groups {
            data {
              Group
              Requires_Register
              Recordings_Available
              Requires_Stage
              Hide_Main_Agenda
              Job
              Delivery
              Format
              Location
            }
          }
          Capacity
          Stream {
            data {
              Stream_Name
            }
          }
          Stage {
            id
            data {
              Stage_Name
              Stage_Colour
              Stage_Slug
              Stage_Priority
            }
          }
        }
      }
    }
  }
`
